import { useReducer } from "react";

import { gql } from "apollo-boost";

import moment from "../Moment";

import ApolloClient from "../services/apollo";

import { useTicketState, useTicketStateGroupByItem, Ticket } from "../interfaces/ticket";

const GET_TICKETS = gql`
  query getTickets {
    getTickets {
      id
      price
      date
      hour
      minutes
      status
      arrivalLocation {
        id
        name
      }
      departureLocation {
        id
        name
      }
      client {
        id
        name
        phone
        photo
        cic
      }
    }
  }
`;

const initialState: useTicketState = {
  list: [],
  listGroup: [],
  error: false,
  loading: true,
  success: false
};

interface Action {
  type: "loading" | "list" | "error" | "success" | "groupBy" | "clearList";
  value?: any;
}

const groupBy = (list: Array<useTicketStateGroupByItem>, newValues: Array<Ticket>) => {
  const listGroupBy: Array<useTicketStateGroupByItem> = list;
  for(const row of newValues) {
    const datetime = moment(`${row.date} ${row.hour}:${row.minutes}`);
    let rowExist = list.find((item: any) => 
      datetime.isSame(moment(item.datetime)) 
      && item.departureLocation.name === row.departureLocation.name
      && item.arrivalLocation.name === row.arrivalLocation.name
    );

    const item: useTicketStateGroupByItem = {
      datetime,
      length: 1,
      items: [],
      departureLocation: row.departureLocation,
      arrivalLocation: row.arrivalLocation
    };

    if (!rowExist) {
      item.items.push(row);
      list.push(item);
    }
    if (rowExist) {
      rowExist.items.push(row);
    }
  }

  return listGroupBy;
}

const reducer = (state: useTicketState, action: Action) => {
  switch (action.type) {
    case "loading":
      return {
        ...state,
        loading: action.value,
      };
    case "success":
      return {
        ...state,
        success: action.value,
      };
    case "error":
      return {
        ...state,
        error: action.value,
      };
    case "groupBy":
      return {
        ...state,
        listGroup: groupBy(state.list, action.value)
      };
    case "clearList":
      return {
        ...state,
        listGroup: [],
        list: []
      };
    case "list":
      return {
        ...state,
        list: [...state.list, ...action.value]
      };
    default:
      return state;
  }
};

export const useTickets = () => {

  const [{ list, loading, error, listGroup }, dispatch] = useReducer(
    reducer,
    initialState
  );

  const fetch = async () => {
    try {
      dispatch({ type:"clearList", value: [] });

      const { data } = await ApolloClient.query({
        query: GET_TICKETS,
        fetchPolicy: "no-cache"
      });
      dispatch({ type:"loading", value: false });
      dispatch({ type: "groupBy", value: data.getTickets });
    } catch(err) {
      console.log(err);
      dispatch({ type:"loading", value: false });
      dispatch({type: "error", value: err});
    }
  };

  return {
    loading,
    error,
    list,
    listGroup,
    refetch: async () => {
      dispatch({ type:"loading", value: true });
      // dispatch({ type:"loading", value: true });
      dispatch({ type:"clearList", value: [] });
      return fetch();
    }
  };
};